var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navs"},[_vm._l((_vm.list),function(item,index){return [(index <= 3)?_c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.gopage(item.link)}}},[_c('img',{staticClass:"item-img",attrs:{"src":item.img}})]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }